import PropTypes from 'prop-types';

export default {
  active: PropTypes.number,
};
